export default __webpack_public_path__ + "56dc03dfd5d21e3f32126421ebc00230.mp3";